import Vue from 'vue'
import VideoPlayer from 'vue-videojs7'

Vue.use(VideoPlayer)
